import { isAppWebView, isMobile } from '../userAgent';

export type Category =
  | 'my'
  | 'card_opening'
  | 'creator'
  | 'general'
  | 'home'
  | 'my_box'
  | 'onboarding'
  | 'cart'
  | 'shop'
  | 'sign_out'
  | 'delivery'
  | 'order'
  | 'poll'
  | 'series'
  | 'code'
  | 'collect'
  | 'category'
  | 'sales'
  | 'channel'
  | 'post'
  | 'class'
  | 'player'
  | 'apply'
  | 'search';

type Platform = 'pc_web' | 'mobile_web' | 'mobile_app_webview';

export type CardOpeningEvents =
  | 'enter_vuddy_card_opening_sequence'
  | 'click_vuddy_card_opening_button';

export type CreatorEvents =
  | 'click_top_bar_creator'
  | 'click_bottom_sheet_my_creator'
  | 'enter_creator_tab'
  | 'click_creator_social_link'
  | 'click_order_download_sheet_button';

export type GeneralEvents =
  | 'enter_my_account'
  | 'click_alarm_icon'
  | 'click_my_icon'
  | 'click_alarm_detail'
  | 'click_mybox_icon'
  | 'click_mybox_menu'
  | 'enter_alarm'
  | 'enter_my'
  | 'enter_my_box'
  | 'click_cart_icon'
  | 'click_cart_menu'
  | 'click_web_gnb_home'
  | 'click_web_gnb_hamburger'
  | 'click_web_side_menu_home'
  | 'click_web_side_menu_profile'
  | 'click_web_side_menu_chat'
  | 'click_web_side_menu_my'
  | 'click_web_side_menu_mybox'
  | 'click_web_side_menu_myclass'
  | 'click_web_side_menu_studio';

export type HomeEvents =
  | 'click_creator_vuddy_home'
  | 'click_my_box_vuddy_home'
  | 'click_shop_vuddy_home'
  | 'click_channel_bottom_sheet_vuddy_home'
  | 'enter_home'
  | 'click_home_headline'
  | 'click_notice'
  | 'click_my_creator'
  | 'click_category_tab_menu'
  | 'click_recommended_sale'
  | 'click_recommended_channel'
  | 'click_recommended_channel_all'
  | 'click_goods_toast'
  | 'click_banner_category'
  | 'click_category_banner'
  | 'click_category_channel'
  | 'click_gnb_search'
  | 'click_home_search';

export type MyBoxEvents =
  | 'enter_my_box'
  | 'click_my_box_vuddy_card'
  | 'enter_vuddy_card_viewer'
  | 'enter_vuddy_card_viewer_back'
  | 'enter_media_viewer'
  | 'click_media_viewer_download'
  | 'click_media_viewer_maximize'
  | 'click_my_box_channel_filter_item'
  | 'click_my_box_media_type'
  | 'click_my_box_gallery'
  | 'click_my_box_channel_filter_multi'
  | 'click_my_box_filter_refresh';

export type OnboardingEvents =
  | 'enter_login_screen'
  | 'enter_email_verification_screen'
  | 'enter_authentication_code_input_screen'
  | 'enter_terms_conditions_screen'
  | 'enter_creator_selection_screen'
  | 'click_login_button_google'
  | 'click_login_button_apple'
  | 'click_login_button_naver'
  | 'enter_email_verification_screen'
  | 'click_creator_selection_category'
  | 'click_creator_selection_skip'
  | 'click_creator_search_icon'
  | 'click_creator_search_result'
  | 'click_creator_search_back'
  | 'click_creator_search_input_triggered'
  | 'click_creator_search_typing_started'
  | 'click_login_external_browser_open';

export type ShopEvents =
  | 'click_sale_comment_more_button'
  | 'click_sale_comment_modification'
  | 'click_sale_comment_delete'
  | 'click_sale_comment_input'
  | 'click_sale_bottom_buy'
  | 'click_sale_buy'
  | 'enter_sale_comment'
  | 'click_sale_comment'
  | 'enter_sale'
  | 'click_shop_sale'
  | 'enter_shop'
  | 'click_sale_comment_report'
  | 'click_sale_share'
  | 'click_shop_banner'
  | 'click_sale_go_to_channel'
  | 'enter_class_sale'
  | 'click_class_sale'
  | 'follow_channel'
  | 'unfollow_channel';

export type SignOutEvents =
  | 'click_email_verification_and_sign_out_button'
  | 'enter_complete_sign_out_screen'
  | 'enter_sign_out_authentication_code_input_screen'
  | 'enter_sign_out_creator'
  | 'enter_sign_out_normal'
  | 'click_my_account_sign_out';

export type DeliveryEvents =
  | 'enter_manage_delivery_info'
  | 'click_add_delivery_info_button'
  | 'click_search_address_button'
  | 'click_save_delivery_address_button'
  | 'click_select_delivery_address_button'
  | 'click_edit_delivery_address_button'
  | 'click_delete_delivery_address_button'
  | 'enter_delete_delivery_popup'
  | 'click_popup_delete_delivery_address_button';

export type OrderEvents =
  | 'enter_order_page'
  | 'click_manage_delivery_info'
  | 'click_add_delivery_info'
  | 'click_payment_method'
  | 'click_buy_button'
  | 'click_service_agreement'
  | 'click_privacy_agreement'
  | 'click_order_agree_check'
  | 'enter_completed_order'
  | 'click_view_order_detail_button'
  | 'click_go_to_shoppoing_button'
  | 'click_open_card_button'
  | 'enter_order_list'
  | 'click_order_detail_button'
  | 'click_channelhome_from_orderlist'
  | 'click_channelhome_from_order_page'
  | 'click_channelhome_from_orderdetail'
  | 'click_payment_cancellation_button'
  | 'enter_order_cancel_popup'
  | 'click_order_cancel_fail_icon'
  | 'click_popup_order_cancel_button'
  | 'click_refund_information_button'
  | 'click_confirm_order_button'
  | 'enter_confirm_order_popup'
  | 'click_popup_confirm_order_button'
  | 'click_go_to_series_popup'
  | 'click_orderdetail_address_edit'
  | 'click_order_address_edit'
  | 'click_go_to_myclass_button';

export type PollEvents =
  | 'enter_vote_completed'
  | 'enter_point'
  | 'enter_vote'
  | 'enter_info';

export type SeriesEvents =
  | 'click_series_poll'
  | 'click_series_sales'
  | 'click_series_schedule'
  | 'click_series_menu'
  | 'enter_series_home';

export type CodeEvents =
  | 'click_close_code_popup'
  | 'click_ok_complete_code_popup'
  | 'enter_complete_code_popup'
  | 'click_check_code_name_button'
  | 'enter_code'
  | 'click_code_my_menu';

export type CollectEvents =
  | 'enter_collect'
  | 'click_collect_reward_view'
  | 'click_collect_reward_claim'
  | 'click_collect_claimed'
  | 'click_collect_media_item'
  | 'enter_collect_list'
  | 'click_collect_list_close'
  | 'click_collect_list_back'
  | 'click_collect_reward_popup_claim'
  | 'click_collect_reward_popup_edit_info';

export type CategoryEvents =
  | 'enter_category_home'
  | 'click_category_vuddy_home'
  | 'click_category_headline'
  | 'click_search_icon'
  | 'click_search_item'
  | 'click_all_creator'
  | 'click_search_field';

export type SalesEvents = 'click_probability_info_refresh';

export type ChannelEvents =
  | 'click_gnb_my_creator'
  | 'click_floating_tab_menu'
  | 'enter_channel_home'
  | 'click_creator_social_link'
  | 'click_sec_creator_to_creator'
  | 'click_sec_creator_tooltip';

export type PostEvents =
  | 'enter_post_comment'
  | 'click_post'
  | 'click_post_go_to_channel'
  | 'click_post_detail_related_sale_product'
  | 'click_post_list_related_sale_product'
  | 'click_post_detail_share'
  | 'click_post_list_share'
  | 'click_post_list_related_sale'
  | 'click_post_detail_related_sale';

export type CartEvents =
  | 'enter_cart'
  | 'click_add_to_cart_bottomsheet'
  | 'click_remove_unavailable_item_cart'
  | 'click_channelhome_from_cart'
  | 'click_channelhome_from_order_page'
  | 'click_channelhome_from_orderlist'
  | 'click_channelhome_from_orderdetail';

export type MyEvents =
  | 'click_email_edit'
  | 'enter_email_edit_verification_screen'
  | 'enter_edit_authentication_code_input_screen'
  | 'click_myclass_menu';

export type ClassEvents =
  | 'enter_myclass'
  | 'click_myclass_class'
  | 'click_myclass_channel_filter_item'
  | 'click_myclass_filter_refresh'
  | 'click_myclass_channel_filter_multi'
  | 'click_popup_ticket_expiry_extend'
  | 'enter_myclass_detail'
  | 'click_class_content'
  | 'click_myclass_download'
  | 'enter_class_material'
  | 'click_class_material_download_button';

export type PlayerEvents =
  | 'click_popup_resume'
  | 'click_popup_restart'
  | 'click_player_play'
  | 'click_player_restart'
  | 'click_player_pause'
  | 'click_player_fullscreen'
  | 'click_player_next_video'
  | 'click_player_prev_video'
  | 'click_player_playback_speed'
  | 'player_play_video_success';

export type SearchEvents =
  | 'click_gnb_search_item'
  | 'click_gnb_search_back'
  | 'click_gnb_search_typing_started';

export type ApplyEvents =
  | 'click_creator_apply'
  | 'click_creator_apply_guide'
  | 'click_sec_creator_application'
  | 'click_sec_creator_apply'
  | 'click_sec_creator_apply_guide'
  | 'click_sec_creator_identity_reverify'
  | 'click_sec_creator_identity_verify'
  | 'click_sec_creator_step1_identity_next'
  | 'click_sec_creator_step2_settlement_next'
  | 'click_sec_creator_step3_agree_next'
  | 'click_sec_creator_step3_agree_terms'
  | 'enter_apply'
  | 'enter_sec_creator_application_detail'
  | 'enter_sec_creator_step1_identity'
  | 'enter_sec_creator_step2_settlement'
  | 'enter_sec_creator_step3_agree'
  | 'enter_sec_creator_submit_success';

export type EventName<T extends Category> = T extends 'card_opening'
  ? CardOpeningEvents
  : T extends 'my'
    ? MyEvents
    : T extends 'creator'
      ? CreatorEvents
      : T extends 'general'
        ? GeneralEvents
        : T extends 'home'
          ? HomeEvents
          : T extends 'my_box'
            ? MyBoxEvents
            : T extends 'onboarding'
              ? OnboardingEvents
              : T extends 'shop'
                ? ShopEvents
                : T extends 'cart'
                  ? CartEvents
                  : T extends 'sign_out'
                    ? SignOutEvents
                    : T extends 'delivery'
                      ? DeliveryEvents
                      : T extends 'order'
                        ? OrderEvents
                        : T extends 'poll'
                          ? PollEvents
                          : T extends 'series'
                            ? SeriesEvents
                            : T extends 'code'
                              ? CodeEvents
                              : T extends 'collect'
                                ? CollectEvents
                                : T extends 'category'
                                  ? CategoryEvents
                                  : T extends 'sales'
                                    ? SalesEvents
                                    : T extends 'channel'
                                      ? ChannelEvents
                                      : T extends 'post'
                                        ? PostEvents
                                        : T extends 'class'
                                          ? ClassEvents
                                          : T extends 'player'
                                            ? PlayerEvents
                                            : T extends 'apply'
                                              ? ApplyEvents
                                              : T extends 'search'
                                                ? SearchEvents
                                                : never;

/**
 * 현재 플랫폼을 감지합니다.
 * @returns Platform
 */
export const detectPlatform = (): Platform => {
  if (typeof window === 'undefined') {
    return 'pc_web'; // SSR 환경을 위한 기본값
  }

  const userAgent = navigator.userAgent;

  // 앱 웹뷰 감지
  if (isAppWebView(userAgent)) {
    return 'mobile_app_webview';
  }

  // 모바일 브라우저 감지
  if (isMobile(userAgent)) {
    return 'mobile_web';
  }

  // PC 브라우저 감지
  return 'pc_web';
};
